/**
 * ZeroPath i18n — react-i18next setup
 * Loads translations from public/locales/{{lng}}/{{ns}}.json
 * Persists language in localStorage (zeropath_lang)
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

const STORAGE_KEY = 'zeropath_lang';
const DEFAULT_LANG = 'ro';
const SUPPORTED = ['en', 'ro'];

function getStoredLanguage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED.includes(stored)) return stored;
  } catch (_) {}
  return DEFAULT_LANG;
}

function saveLanguage(lng) {
  try {
    if (SUPPORTED.includes(lng)) localStorage.setItem(STORAGE_KEY, lng);
  } catch (_) {}
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: getStoredLanguage(),
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED,
    ns: ['common', 'auth', 'nav', 'tasks', 'protocols', 'execution', 'validation', 'setup', 'dashboards', 'userManagement', 'rbac', 'clinical', 'ipc', 'patientRisk', 'workflows', 'risks', 'qms', 'recommendations', 'rca', 'incidents', 'deviations', 'michelangelo', 'nomenclatures', 'riskClassification', 'pwa', 'management', 'icPersonnel'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: false,
    },
  });

// Persist language on change
i18n.on('languageChanged', (lng) => {
  saveLanguage(lng);
});

export default i18n;
export { getStoredLanguage, saveLanguage, STORAGE_KEY, SUPPORTED };
